@if (!isLoading) {
  <div>
    @if (!isCordinatorReadonly) {
      <div>
        <p class="confidentiality-clause">{{ confidentialityClause }}</p>
      </div>
    }
    <cotecna-table
      [data]="(documents | async) ?? []"
      [columns]="columns"
      [actions]="actions"
      [disableActionIcon]="disableActionIcon.bind(this)"
      [hasSelectableColumn]="true"
      [clearAllSelection]="clearAllSelection"
      [hasActionsTitle]="false"
      (selectionChange)="onCheckboxSelected($event)"
      (click)="processAction($event)"
      (toggleChange)="onToogleChanged($event)"
      dateFormat="short"
    >
    </cotecna-table>
    @if (addDocumentAllowed) {
      <comat-fab-speed-dial
        id="speed-dial"
        [actions]="speedDialActions"
        (selectedAction)="onFabSpeedDialSelectedAction($event)"
        mainIcon="add"
        color="accent"
      >
      </comat-fab-speed-dial>
    }
  </div>
}

@if (isLoading) {
  <mat-spinner diameter="32"></mat-spinner>
}
